import type { CSSProperties, ReactNode } from 'react'
import { BottleIcon, DiaperIcon, MoonIcon, NoteIcon } from './Icon'
import s from './TrackChips.module.css'

type Chip = { label: string; color: string; icon: ReactNode }

const CHIPS: Chip[] = [
  { label: 'Feeds', color: 'var(--tb-accent-pink)', icon: <BottleIcon size={19} /> },
  { label: 'Sleep', color: 'var(--tb-accent-blue)', icon: <MoonIcon size={19} /> },
  { label: 'Diapers', color: 'var(--tb-accent-amber)', icon: <DiaperIcon size={19} /> },
  { label: 'Notes', color: 'var(--tb-accent-yellow)', icon: <NoteIcon size={19} /> },
]

export function TrackChips() {
  return (
    <div className={s.wrap}>
      <h2 className={s.label} id="track-label">
        Everything you'll track
      </h2>
      <ul className={s.row} aria-labelledby="track-label">
        {CHIPS.map((chip) => (
          <li className={s.chip} key={chip.label}>
            <span className={s.tile} style={{ '--tile': chip.color } as CSSProperties}>
              {chip.icon}
            </span>
            <span className={s.chipLabel}>{chip.label}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}
